
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/w/e/[event]",
      function () {
        return require("private-next-pages/w/e/[event].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/w/e/[event]"])
      });
    }
  